<form class="pt-8" [formGroup]="formGroup">
  <dgx-dfb-input
    [field]="field"
    [formControlName]="field.controlName"
    [validate]="validateField"
  ></dgx-dfb-input>
</form>
